import script from "./ProfileCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileCard.vue?vue&type=script&setup=true&lang=js"

import "./ProfileCard.vue?vue&type=style&index=0&id=10e526bf&lang=css"

const __exports__ = script;

export default __exports__